import { DataWrapper } from '@app/components/DataWrapper';
import {
  getAllScholarships,
  ScholarshipData,
} from '@app/services/studentOpportunitiesService';
import { Card, Stack } from '@mui/material';
import { TableRowActions } from './TableRowActions';
import { OpportunityCard } from './OpportunityCard';

export function Table() {
  return (
    <DataWrapper<ScholarshipData>
      id="scholarships"
      filterConfig={[]}
      fetchData={getAllScholarships}
      render={data => (
        <Stack gap={2}>
          {data.map((item, index) => (
            <Card key={item.id}>
              <Stack>
                <OpportunityCard
                  index={index}
                  title={item.title}
                  deadlineDate={item.closeDate}
                  openDate={item.openDate}
                  minimumGPA={item.minimumGpa}
                  academicClassifications={item.academicClassification}
                  description={item.description}
                  link={item.link}
                >
                  <TableRowActions data={item} />
                </OpportunityCard>
              </Stack>
            </Card>
          ))}
        </Stack>
      )}
    />
  );
}
